<template>
  <div class="app" style="color:#333333;">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav">
      </Sidebar>
      <main class="main">
        <br>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import cpunav from '../_cpunav'
import { Header as AppHeader, Sidebar, Footer as AppFooter } from '../components/'
import Store from '@/store'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter
  },
  data () {
    if (Store.state.companyid === 'DEV99997' || Store.state.companyid === '3DPLAYER_ADMIN') {
      return {
        nav: cpunav.items
      }
    } else {
      return {
        nav: nav.items
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue